import { render, staticRenderFns } from "./ConferenciaList.vue?vue&type=template&id=04fe3dfb"
import script from "./ConferenciaList.vue?vue&type=script&lang=js"
export * from "./ConferenciaList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports